import * as lexActionType from '../actionsType/lexLicenseMode.actionType';

export const initialState = {
    response: null,
    exception: null
};

export function licenseModeReducer(state = initialState, action) {
    switch (action.type) {
        case lexActionType.LEX_LICENSE_MODE_REQUEST_SUCCESS:
            return {...state, response: action.payload};
        case lexActionType.LEX_LICENSE_MODE_REQUEST_ERROR:
            return {...state, exception: lexActionType.LEX_LICENSE_MODE_REQUEST_ERROR};
        default:
            return state;
    }
}
